export default __webpack_public_path__ + "static/media/gutargu0.2a066246.png";